export var CreatorEventFulfilledDareStatus;
(function (CreatorEventFulfilledDareStatus) {
    CreatorEventFulfilledDareStatus["Pending"] = "PENDING";
    CreatorEventFulfilledDareStatus["Enabled"] = "ENABLED";
    CreatorEventFulfilledDareStatus["Disabled"] = "DISABLED";
})(CreatorEventFulfilledDareStatus || (CreatorEventFulfilledDareStatus = {}));
